/**
 * Источник КЭИ/АВБ для отчёта и доп. блоков: доработка, только если в ней уже есть ka;
 * иначе основная экспертиза (пустой kei-mod не перекрывает kei).
 */
export function pickKeiReportSource(initData) {
  if (!initData) return null
  const mod = initData['kei-mod']
  const base = initData.kei
  if (mod?.ka?.length) return mod
  return base || null
}

export function pickAvbReportSource(initData) {
  if (!initData) return null
  const mod = initData['avb-mod']
  const base = initData.avb
  if (mod?.ka?.length) return mod
  return base || null
}
